import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

const HARDCODED = {
	title: "Kenapa Jogja Madrasah Digital?",
	items: [
		{
			icon: "FaShieldAlt",
			title: "Transformasi Digital Terpadu",
			desc: "Mengintegrasikan seluruh sistem administrasi dan akademik madrasah dalam satu platform yang mudah digunakan.",
		},
		{
			icon: "FaLaptop",
			title: "Ekosistem Belajar Modern",
			desc: "Menciptakan lingkungan belajar yang interaktif dengan modul digital dan monitoring progres belajar secara real-time.",
		},
		{
			icon: "FaGraduationCap",
			title: "Kolaborasi Tanpa Batas",
			desc: "Menghubungkan guru, siswa, dan orang tua secara instan untuk menciptakan transparansi pendidikan yang lebih baik.",
		},
	],
};

function KenapaJMD() {
	const [isVisible, setIsVisible] = useState(false);
	const [data, setData] = useState(HARDCODED);
	const sectionRef = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) setIsVisible(true);
			},
			{ threshold: 0.2 }
		);
		if (sectionRef.current) observer.observe(sectionRef.current);
		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		axios
			.get("/api_w/abouts", {
				params: { title: "home:kenapa-jmd" },
				headers: { db_name: process.env.REACT_APP_DB_NAME },
			})
			.then((res) => {
				const item = res.data.data?.[0];
				if (item?.body) {
					const parsed = JSON.parse(item.body);
					if (parsed?.items) setData(parsed);
				}
			})
			.catch(() => {});
	}, []);

	return (
		<section aria-label="Kenapa JMD"
			ref={sectionRef}
			className="py-24 px-4 md:px-20 bg-white overflow-hidden"
		>
			<div className="max-w-8xl mx-auto">
				<div className="flex flex-col lg:flex-row items-center gap-16">
					<div
						className={`w-full lg:w-1/2 transition-all duration-1000 ${
							isVisible
								? "translate-x-0 opacity-100"
								: "-translate-x-20 opacity-0"
						}`}
					>
						<div className="relative">
							<div className="w-[85%] h-[450px] md:h-[700px] rounded-3xl overflow-hidden shadow-2xl">
								<img
									src="https://images.unsplash.com/photo-1541339907198-e08759df9a73?q=80&w=2070&auto=format&fit=crop"
									alt="Madrasah Building"
									className="w-full h-full object-cover"
									onError={(e) => { e.target.src = "https://placehold.co/600x400/006045/white?text=JMD"; e.target.onerror = null; }}
								/>
							</div>
							<div className="absolute top-1/3 right-0 -translate-y-1/2 w-[60%] bg-white p-4 rounded-3xl shadow-2xl animate-float">
								<div className="rounded-2xl overflow-hidden mb-4 aspect-video">
									<img
										src="https://images.unsplash.com/photo-1509062522246-3755977927d7?q=80&w=2132&auto=format&fit=crop"
										alt="Classroom"
										className="w-full h-full object-cover"
										onError={(e) => { e.target.src = "https://placehold.co/600x400/006045/white?text=JMD"; e.target.onerror = null; }}
									/>
								</div>
								<h3 className="text-lg font-bold text-gray-800 mb-1">
									Kemenag Yogyakarta
								</h3>
								<p className="text-sm text-gray-500 leading-normal">
									Peluncuran platform Jogja Madrasah Digital merupakan langkah
									strategis dalam transformasi pendidikan di lingkungan
									madrasah.
								</p>
							</div>
						</div>
					</div>

					<div
						className={`w-full lg:w-1/2 transition-all duration-1000 delay-300 ${
							isVisible
								? "translate-x-0 opacity-100"
								: "translate-x-20 opacity-0"
						}`}
					>
						<h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4 leading-tight">
							{data.title?.includes("?")
								? data.title.split("?")[0]
								: data.title || "Kenapa"}{" "}
							<br />
							{/* <span className="text-green-700">{data.title?.includes("?") ? data.title : "Jogja Madrasah Digital?"}</span> */}
						</h2>

						<div className="space-y-6 mt-8">
							{data.items.map((item, idx) => (
								<div key={idx} className="flex gap-4 group">
									<div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mt-1 group-hover:bg-green-600 transition-colors duration-300">
										<svg
											className="w-4 h-4 text-green-600 group-hover:text-white transition-colors duration-300"
											fill="none"
											stroke="currentColor"
											viewBox="0 0 24 24"
										>
											<path
												strokeLinecap="round"
												strokeLinejoin="round"
												strokeWidth={3}
												d="M5 13l4 4L19 7"
											/>
										</svg>
									</div>
									<div>
										<h3 className="font-semibold text-gray-800 text-lg mb-1 group-hover:text-green-700 transition-colors duration-300">
											{item.title}
										</h3>
										<p className="text-base text-gray-500 leading-relaxed max-w-md">
											{item.desc}
										</p>
									</div>
								</div>
							))}
						</div>

						<button className="mt-10 bg-green-600 hover:bg-green-700 text-white font-bold px-8 py-3 rounded-full shadow-lg shadow-green-600/20 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
							Baca Selengkapnya
						</button>
					</div>
				</div>
			</div>
		</section>
	);
}

export default KenapaJMD;
